import { render, staticRenderFns } from "./item_cost_price.vue?vue&type=template&id=2cc0e7f1&"
import script from "./item_cost_price.vue?vue&type=script&lang=js&"
export * from "./item_cost_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports